export function getPlayabilityClasses(ming, maxg) {
    let classes = null;
    if (ming != null) {
        if (maxg === 1 && ming === 1) {
            classes = 'blocco-giocab blocco-giocab--1';
        } else if (ming === 2) {
            classes = 'blocco-giocab blocco-giocab--2';
        } else if (ming === 3) {
            classes = 'blocco-giocab blocco-giocab--3';
        } else if (ming === 4) {
            classes = 'blocco-giocab blocco-giocab--4';
        } else if (ming === 5) {
            classes = 'blocco-giocab blocco-giocab--5';
        }
    }

    return classes;
}
